export const getDeviceType = (): string => {
    const userAgent =
        navigator.userAgent ||
        navigator.vendor ||
        (window as Window & { opera?: string }).opera ||
        ''

    const isPWA = window.matchMedia('(display-mode: standalone)').matches

    if (isPWA) {
        return 'PWA'
    }

    const isMobile =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
            userAgent.toLowerCase()
        )

    if (isMobile) {
        return 'Mobile'
    }

    // Default to Desktop
    return 'Desktop'
}
